import { Profile } from 'app/redux/Profile/model';
import { configName } from 'config'
import { IOPensionCalculations } from '.';
import { IOLocal697PensionCalculations } from './Local697';

/*
 *  Make a IOPension calculator appropriate to the confguration.
 */
function makeIOComputer(profile: Profile, pensionText: string = 'IO') {

  if (configName === '697') {
    return new IOLocal697PensionCalculations(profile, pensionText)
  }

  return new IOPensionCalculations(profile, pensionText)
}

export {
  makeIOComputer
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/IO/Factory.ts